import React from 'react';

interface InfoBoxProps {
  title?: string;
  children?: React.ReactNode;
}

export default function InfoBox({ title, children }: InfoBoxProps) {
  return (
    <div className="my-6 p-4 border-l-4 border-blue-500 bg-blue-50">
      {title && <h4 className="text-lg font-semibold mb-2">{title}</h4>}
      {children}
    </div>
  );
} 